// The project page's DATE format, moved here unchanged from project-detail.tsx
// (2026-10-02, item #680) so the For finance panel can render it from its own
// file and be tested without loading the page.
/**
 * A DATE column, rendered as the day it actually says.
 *
 * ⚠️ Run C Phase 4, 2026-08-19. `new Date('2026-08-05')` parses a bare date as
 * UTC MIDNIGHT, and toLocaleDateString then renders it in local time — so west
 * of Greenwich every date column displayed ONE DAY EARLY. It was showing
 * 8/4/2026 for a service performed on the 5th, and Run C's per-line payment
 * panel would have printed that wrong day next to a subcontractor's money.
 *
 * Splitting the parts and constructing a LOCAL date fixes it. Timestamps (which
 * carry a zone) still go through the normal path.
 */
export function fmtDate(s: string | null | undefined): string {
  if (!s) return '—';
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s.trim());
  if (m) {
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString();
  }
  try { return new Date(s).toLocaleDateString(); } catch { return s; }
}
